import script from "./CourseActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseActivity.vue?vue&type=script&setup=true&lang=js"

import "./CourseActivity.vue?vue&type=style&index=0&id=7d0ee66e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0ee66e"]])

export default __exports__